<section
  id="login-content"
  customerScreenType
  class="s-full fx-row fx-center">
  <customer-azzurro-inverter
    customerScreenType
    id="login-welcome"
    class="s-full overflow-auto">
  </customer-azzurro-inverter>
  <section class="h-full w-3p min-w-100">
    <app-forgot-password
      customerScreenType
      class="w-full">
    </app-forgot-password>
  </section>
</section>
